/* ============================================================
   BRICKIES — Storefront-Verhalten
   Kein Framework, keine Abhaengigkeiten. Alles was hier laeuft,
   arbeitet mit echten Shop-Daten: Bestand aus Shopify, Warenkorb
   aus /cart.js, Liefertermin aus dem realen Kalender.
   ============================================================ */
(function () {
  'use strict';

  var CFG = Object.assign({
    tz: 'Europe/Berlin',
    cutoffHour: 14,
    transitDays: 2,
    freeShipFrom: 79,
    currency: 'EUR',
    locale: 'de-DE'
  }, window.BRICKIES_CONFIG || {});

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var money = new Intl.NumberFormat(CFG.locale, { style: 'currency', currency: CFG.currency });

  /* ---------------------------------------------------------
     Zeit & Feiertage
     Rechnet auf der Berliner Wanduhr, damit der Liefertermin
     unabhaengig von der Zeitzone des Besuchers stimmt.
     --------------------------------------------------------- */

  // Liefert ein Date-Objekt, dessen UTC-Felder die Berliner Wanduhr abbilden.
  function wallClock(date) {
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: CFG.tz, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    });
    var p = {};
    f.formatToParts(date || new Date()).forEach(function (x) { p[x.type] = x.value; });
    return new Date(Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second));
  }

  // Gauss'sche Osterformel – Basis fuer die beweglichen Feiertage.
  function easter(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(year, month - 1, day);
  }

  var holidayCache = {};
  // Bundesweite gesetzliche Feiertage. Laenderspezifische bewusst ausgelassen –
  // ein zu optimistischer Termin kostet mehr Vertrauen als ein zu vorsichtiger.
  function holidays(year) {
    if (holidayCache[year]) return holidayCache[year];
    var DAY = 86400000, e = easter(year);
    var set = {};
    [
      Date.UTC(year, 0, 1),    // Neujahr
      e - 2 * DAY,             // Karfreitag
      e + 1 * DAY,             // Ostermontag
      Date.UTC(year, 4, 1),    // Tag der Arbeit
      e + 39 * DAY,            // Christi Himmelfahrt
      e + 50 * DAY,            // Pfingstmontag
      Date.UTC(year, 9, 3),    // Tag der Deutschen Einheit
      Date.UTC(year, 11, 25),  // 1. Weihnachtstag
      Date.UTC(year, 11, 26)   // 2. Weihnachtstag
    ].forEach(function (t) { set[t] = true; });
    holidayCache[year] = set;
    return set;
  }

  function isBusinessDay(d) {
    var wd = d.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    var midnight = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    return !holidays(d.getUTCFullYear())[midnight];
  }

  function addBusinessDays(d, n) {
    var out = new Date(d.getTime());
    while (n > 0) {
      out.setUTCDate(out.getUTCDate() + 1);
      if (isBusinessDay(out)) n--;
    }
    return out;
  }

  // Naechster Versandtag + voraussichtlicher Liefertag.
  function shippingForecast() {
    var now = wallClock();
    var dispatch = new Date(now.getTime());
    var sameDay = isBusinessDay(now) && now.getUTCHours() < CFG.cutoffHour;
    if (!sameDay) dispatch = addBusinessDays(now, 1);

    var delivery = addBusinessDays(dispatch, CFG.transitDays);
    var cutoff = new Date(Date.UTC(
      now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), CFG.cutoffHour, 0, 0
    ));
    return { now: now, dispatch: dispatch, delivery: delivery, sameDay: sameDay, msToCutoff: cutoff - now };
  }

  var fmtDay = new Intl.DateTimeFormat(CFG.locale, {
    weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC'
  });

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---------------------------------------------------------
     Feature 1 – Lieferversprechen mit Countdown
     --------------------------------------------------------- */
  function mountDelivery(el) {
    if (el.dataset.bkMounted) return;
    el.dataset.bkMounted = '1';

    var dateEl  = $('.bk-deliver__date', el);
    var cdEl    = $('.bk-countdown', el);
    var noteEl  = $('.bk-deliver__cut', el);

    function tick() {
      var f = shippingForecast();
      var dayText = fmtDay.format(f.delivery);
      if (dateEl && dateEl.textContent !== dayText) dateEl.textContent = dayText;

      if (f.sameDay && f.msToCutoff > 0) {
        var s = Math.floor(f.msToCutoff / 1000);
        var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
        var cd = pad(h) + ':' + pad(m) + ':' + pad(sec);
        if (cdEl && cdEl.textContent !== cd) cdEl.textContent = cd;
        if (noteEl && noteEl.textContent !== 'bis Versand heute') noteEl.textContent = 'bis Versand heute';
        if (cdEl) cdEl.hidden = false;
      } else {
        if (cdEl) cdEl.hidden = true;
        var note = 'Versand am ' + fmtDay.format(f.dispatch);
        if (noteEl && noteEl.textContent !== note) noteEl.textContent = note;
      }
      el.hidden = false;
    }

    tick();
    // Der Intervall prueft selbst, ob der Knoten noch im Dokument haengt.
    // Ein eigener MutationObserver je Element waere teuer und wuerde den
    // globalen Beobachter unnoetig oft wecken.
    var id = setInterval(function () {
      if (!document.contains(el)) { clearInterval(id); return; }
      tick();
    }, 1000);
  }

  /* ---------------------------------------------------------
     Feature 2 – Bestandsbalken
     --------------------------------------------------------- */
  function mountStock(el) {
    var qty = parseInt(el.dataset.qty, 10);
    var max = parseInt(el.dataset.max, 10) || Math.max(qty, 10);
    if (isNaN(qty)) return;
    var fill = $('.bk-stock__fill', el);
    if (fill) {
      var pct = Math.max(0.06, Math.min(1, qty / max));
      requestAnimationFrame(function () { fill.style.transform = 'scaleX(' + pct + ')'; });
    }
  }

  /* ---------------------------------------------------------
     Feature 3 – Gratisversand-Fortschritt im Warenkorb
     Haengt sich an jede Warenkorb-Mutation, egal ob Drawer,
     Seite oder Quick-Add sie ausgeloest hat.
     --------------------------------------------------------- */
  var cartState = null;

  // Baut den Versandbalken in Warenkorb-Drawer und Warenkorb-Seite ein.
  // Horizon rendert beide per Section-API neu, deshalb laeuft das
  // nach jeder Aktualisierung erneut und prueft auf Doppelung.
  function injectShipBars() {
    var hosts = [
      document.querySelector('.cart-drawer__summary'),
      document.querySelector('.cart__summary'),
      document.querySelector('[data-bk-ship-here]')
    ];
    hosts.forEach(function (host) {
      if (!host || host.querySelector(':scope > .bk-ship')) return;
      var bar = document.createElement('div');
      bar.className = 'bk-ship';
      bar.hidden = true;
      bar.innerHTML =
        '<p class="bk-ship__msg"></p>' +
        '<div class="bk-ship__track"><div class="bk-ship__fill"></div></div>';
      host.insertBefore(bar, host.firstChild);
    });
  }

  function renderShipBars() {
    if (!cartState) return;
    var threshold = Math.round(CFG.freeShipFrom * 100);
    var total = cartState.total_price || 0;
    var missing = Math.max(0, threshold - total);
    var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;

    var html = missing === 0
      ? 'Gratisversand freigeschaltet – wir uebernehmen den Versand.'
      : 'Noch <span class="bk-ship__amount">' + money.format(missing / 100) +
        '</span> bis zum kostenlosen Versand.';
    var sig = html + '|' + pct;

    $$('.bk-ship').forEach(function (bar) {
      // Nur schreiben, wenn sich etwas geaendert hat. Jede Mutation weckt
      // sonst den Beobachter, der wiederum hierher zurueckfuehrt.
      if (bar.dataset.bkSig === sig) return;
      bar.dataset.bkSig = sig;

      var msg = $('.bk-ship__msg', bar);
      var fill = $('.bk-ship__fill', bar);
      bar.classList.toggle('bk-ship--done', missing === 0);
      if (msg) msg.innerHTML = html;
      if (fill) fill.style.width = pct + '%';
      bar.hidden = false;
    });
  }

  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) { cartState = c; renderShipBars(); } })
      .catch(function () { /* Warenkorb nicht erreichbar – Balken bleibt wie er ist */ });
  }

  // Warenkorb-Mutationen abfangen, ohne Theme-interne Events vorauszusetzen.
  // Fest an window gebunden: Horizons Module laufen im Strict Mode und rufen
  // fetch() ohne Objektbezug auf. Ein apply(this, ...) uebergaebe dort
  // undefined, und nativer fetch quittiert das mit "Illegal invocation".
  if (typeof window.fetch === 'function') {
    var _fetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var href = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch(input, init);
      if (/\/cart\/(add|change|update|clear)/.test(href)) {
        p.then(function () { setTimeout(refreshCart, 60); }, function () {});
      }
      return p;
    };
  }

  /* ---------------------------------------------------------
     Feature 4 – Merkliste (lokal, ohne App und ohne Konto)
     --------------------------------------------------------- */
  var FAV_KEY = 'brickies:favs';

  function favs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveFavs(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('brickies:favs', { detail: list }));
    updateFavCount();
  }
  function updateFavCount() {
    var n = favs().length;
    $$('[data-bk-fav-count]').forEach(function (el) {
      el.textContent = n ? String(n) : '';
      el.hidden = n === 0;
    });
  }

  function mountFav(btn) {
    if (btn.dataset.bkMounted) return;
    btn.dataset.bkMounted = '1';
    var handle = btn.dataset.handle;
    var on = favs().indexOf(handle) !== -1;
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');

    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var list = favs(), i = list.indexOf(handle);
      if (i === -1) { list.push(handle); toast('Auf die Merkliste gesetzt'); }
      else { list.splice(i, 1); toast('Von der Merkliste entfernt'); }
      saveFavs(list);
      btn.setAttribute('aria-pressed', i === -1 ? 'true' : 'false');
      btn.classList.remove('bk-fav__burst');
      void btn.offsetWidth;
      btn.classList.add('bk-fav__burst');
    });
  }

  /* ---------------------------------------------------------
     Feature 5 – Set-Vergleich
     --------------------------------------------------------- */
  var CMP_KEY = 'brickies:compare';
  function cmp() {
    try { return JSON.parse(sessionStorage.getItem(CMP_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveCmp(list) {
    try { sessionStorage.setItem(CMP_KEY, JSON.stringify(list.slice(0, 3))); } catch (e) {}
    renderCmpBar();
  }

  function renderCmpBar() {
    var bar = $('.bk-compare-bar');
    if (!bar) return;
    var list = cmp();

    // Signatur der dargestellten Auswahl. Ohne diese Klammer baut die
    // Funktion die Leiste bei jedem Aufruf neu auf, die Mutationen wecken
    // den Beobachter, der wieder hierher fuehrt – eine Endlosschleife,
    // die das Rendern der Seite blockiert.
    var sig = list.map(function (o) { return o.handle; }).join(',');
    if (bar.dataset.bkSig === sig) return;
    bar.dataset.bkSig = sig;

    var slots = $('.bk-compare-bar__slots', bar);
    var link = $('.bk-compare-bar__go', bar);
    if (slots) {
      slots.innerHTML = '';
      for (var i = 0; i < 3; i++) {
        var s = document.createElement('div');
        s.className = 'bk-compare-slot' + (list[i] ? ' bk-compare-slot--filled' : '');
        if (list[i]) {
          if (list[i].img) s.style.backgroundImage = 'url(' + list[i].img + ')';
          s.title = list[i].title || '';
          var x = document.createElement('button');
          x.className = 'bk-compare-slot__x'; x.type = 'button';
          x.setAttribute('aria-label', 'Aus dem Vergleich entfernen');
          x.textContent = '×';
          (function (handle) {
            x.addEventListener('click', function () {
              saveCmp(cmp().filter(function (o) { return o.handle !== handle; }));
            });
          })(list[i].handle);
          s.appendChild(x);
        }
        slots.appendChild(s);
      }
    }
    if (link) {
      link.href = '/pages/vergleich?sets=' + list.map(function (o) { return o.handle; }).join(',');
      link.hidden = list.length < 2;
    }
    bar.classList.toggle('bk-compare-bar--open', list.length > 0);
  }

  function mountCompare(btn) {
    if (btn.dataset.bkMounted) return;
    btn.dataset.bkMounted = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var entry = { handle: btn.dataset.handle, title: btn.dataset.title, img: btn.dataset.img };
      var list = cmp().filter(function (o) { return o.handle !== entry.handle; });
      if (list.length >= 3) { toast('Maximal drei Sets im Vergleich'); return; }
      list.push(entry);
      saveCmp(list);
      toast('Zum Vergleich hinzugefuegt');
    });
  }

  /* ---------------------------------------------------------
     FAQ-Akkordeon
     --------------------------------------------------------- */
  function mountFaq(item) {
    if (item.dataset.bkMounted) return;
    item.dataset.bkMounted = '1';
    var q = $('.bk-faq__q', item);
    if (!q) return;
    q.addEventListener('click', function () {
      var open = item.dataset.open === 'true';
      item.dataset.open = open ? 'false' : 'true';
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  /* ---------------------------------------------------------
     Einblenden beim Scrollen
     --------------------------------------------------------- */
  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('bk-reveal--in'); obs.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;

  /* ---------------------------------------------------------
     Toast
     --------------------------------------------------------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bk-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('bk-toast--show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('bk-toast--show'); }, 2400);
  }

  /* ---------------------------------------------------------
     Montage – idempotent, laeuft nach jedem Section-Rerender
     --------------------------------------------------------- */
  function mountAll(root) {
    root = root || document;
    injectShipBars();
    $$('.bk-deliver', root).forEach(mountDelivery);
    $$('.bk-stock', root).forEach(mountStock);
    $$('.bk-fav', root).forEach(mountFav);
    $$('[data-bk-compare]', root).forEach(mountCompare);
    $$('.bk-faq__item', root).forEach(mountFaq);
    if (revealObserver) $$('.bk-reveal:not(.bk-reveal--in)', root).forEach(function (el) { revealObserver.observe(el); });
    updateFavCount();
    renderCmpBar();
    renderShipBars();
  }

  function init() {
    mountAll(document);
    refreshCart();

    // Horizon rendert Sections per Fetch neu – neu eingefuegte Knoten
    // nachziehen. Der Beobachter darf sich dabei nicht selbst ausloesen:
    // mountAll veraendert das DOM, und ohne Sperre faende sich der Aufruf
    // sofort wieder in der Warteschlange.
    var scheduled = false;
    var mounting = false;

    var observer = new MutationObserver(function () {
      if (mounting || scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        mounting = true;
        try {
          mountAll(document);
        } finally {
          // Was mountAll selbst veraendert hat, aus der Warteschlange werfen.
          requestAnimationFrame(function () {
            observer.takeRecords();
            mounting = false;
          });
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.BRICKIES = {
    favs: favs, toast: toast, forecast: shippingForecast, refreshCart: refreshCart, mount: mountAll
  };
})();
